import mutate from '@wittignl/js-core/apollo/mutations/mutate'
import invalidateFragment from '@wittignl/js-core/apollo/mutations/invalidateFragment'

import CreateUserMutation from 'gql/mutations/user/CreateUser.gql'
import UpdateUserMutation from 'gql/mutations/user/UpdateUser.gql'
import DeleteUserMutation from 'gql/mutations/user/DeleteUser.gql'
import ConnectUsersToProject from 'gql/mutations/user/ConnectUsersToProject.gql'
import UpdateUserRolesMutation from 'gql/mutations/user/UpdateUserRoles.gql'

export default class {

    static create(input){

        return mutate(CreateUserMutation, { input });
    }

    static update(input){

        return mutate(UpdateUserMutation, { input }, store => {

            invalidateFragment(store, 'User', input.id);
        });
    }

    static delete(id){

        return mutate(DeleteUserMutation, { id });
    }

    static connectUsersToProject(projectId, userIds) {

        return mutate(ConnectUsersToProject, { projectId, userIds });
    }

    static updateUserRoles(userId, roles) {

        return mutate(UpdateUserRolesMutation, { userId, roles });
    }
}
